/*eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">Prompt Name</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_name"
                    type="text"
                    class="form-control"
                    placeholder="Enter prompt name"
                    required
                  />
                </div>

                <div class="col-md-12 mb-3">
                  <label for="validationemail_body"> {{cvPromptService}}</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_service"
                    type="text"
                    class="form-control"
                    placeholder="E.g: API_SERVICE"
                    required
                  />
                </div>
               <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{cvPromptModuleNameLabel}}</label><br>
                  <select
                    v-model="vmchatbotPromptFormData.prompt_module_name"
                    class="form-control"
                    required
                  >
                    <option :value="null" disabled>Choose Module</option>
                    <option v-for="(module, index) of (propOpenedInModal ? propModules : modules)" :key="(index+1)" :value="module.mod_name">
                      {{module.mod_name}}
                    </option>
                  </select>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationemail_body">{{ cvPromptLabel }}</label>
                  <b-form-textarea
                    id="validationemail_body"
                    v-model="vmchatbotPromptFormData.prompt"
                    rows="6"
                    max-rows="12"
                    placeholder="Enter prompt..."
                    required
                  ></b-form-textarea>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationmodule_name">{{cvPromptMacrosLabel}}</label><br>
                  <input
                    v-model="vmchatbotPromptFormData.prompt_macro"
                    type="text"
                    placeholder="Comma-separated macros (e.g. PROMPT_CHATBOT_NAME,PROMPT_QUESTION,PROMPT_ANSWER_CHOICES)"
                    class="form-control"
                    required
                  />
                </div>
                <!-- <div class="col-md-12 mb-3">
                  <label for="validationmodule_object_id">{{cvPromptResponseLabel}}</label>
                  <b-form-textarea
                    id="validationemail_body"
                    v-model="vmchatbotPromptFormData.prompt_response"
                    rows="3"
                    max-rows="12"
                    placeholder="Enter prompt response..."
                    required
                  ></b-form-textarea>
                </div> -->
                <button :disabled="cvLoadingStatus" type="button" class="btn btn-primary mx-2" @click="chatbotPromptEdit()">{{ cvSubmitBtn }}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { ChatbotPromptApiObj } from "../../../FackApi/api/chatbotPrompt.js"
import { moduleApiObj } from "../../../FackApi/api/module.js"

export default {
  name: "chatbotPromptEdit",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propModules: {
      type: Array,
      default: function () {
        return []
      }
    },
    propChatbotPromptObj: {
      type: Object,
      default: function () {
        return {
          prompt_name: "",
          prompt_service: "",
          prompt_module_name: "",
          prompt: "",
          prompt_macro: null
        }
      }
    }
  },
  data () {
    return {
      cvCardTitle: "Edit Chatbot Prompt",
      cvSubmitBtn: "Edit",
      cvPromptService: "Prompt Service",
      cvPromptModuleNameLabel: "Prompt Module Name",
      cvPromptLabel: "Prompt",
      cvPromptMacrosLabel: "Prompt Macros",
      cvPromptResponseLabel: "Prompt Response",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Prompt",
      vmchatbotPromptFormData: {},
      vmAdminEmailTempDesc: null,
      vmAdminEmailTempType: null,
      modules: []
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
    if (this.propOpenedInModal && this.propChatbotPromptObj && Object.keys(this.propChatbotPromptObj).length) {
      this.vmchatbotPromptFormData = Object.assign({}, this.propChatbotPromptObj)
    }
    else if (!this.propOpenedInModal) {
      // for full page
      // get module list
      this.moduleList()

      // call the api to get the details
      const promptId = this.$route.params.prompt_id
      if (promptId) {
        this.chatbotPromptView(promptId)
      }
    }
  },
  methods: {
    /**
     * moduleList (full page only)
     */
    async moduleList () {
      try {
        const moduleListResp = await moduleApiObj.moduleList(this)
        if (moduleListResp && moduleListResp.resp_status) {
          this.modules = moduleListResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at moduleList() and Exception:", err.message)
      }
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        prompt_name: "",
        prompt_service: "",
        prompt_module_name: "",
        prompt: "",
        prompt_macro: null
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmchatbotPromptFormData) {
          if (!this.vmchatbotPromptFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          if (index === "prompt_macro") {
            const promptMacro = this.vmchatbotPromptFormData[index].trim()
            // Allow only uppercase letters, underscores and commas
            const validFormat = /^[A-Z_]+(,[A-Z_]+)*$/
            if (!validFormat.test(promptMacro)) {
              this.toastMsg = "Prompt Macro must contain only uppercase letters and underscores. Multiple macros must be comma separated."
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }

            // Check for empty values between commas
            if (promptMacro.includes(",") && promptMacro.split(",").some(macro => !macro.trim())) {
              this.toastMsg = "Prompt Macro cannot contain empty values"
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * chatbotPromptEdit
     */
    async chatbotPromptEdit () {
      if (!this.validate()) {
        return false
      }

      try {
        this.cvLoadingStatus = true

        let chatbotPromptEditResp = await ChatbotPromptApiObj.chatbotPromptEdit(this, this.vmchatbotPromptFormData)
        if (chatbotPromptEditResp && !chatbotPromptEditResp.resp_status) {
          this.toastMsg = "Failed to edit prompt"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        this.toastMsg = "Prompt edited successfully"
        this.toastVariant = "success"
        this.showToast = true

        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitClosechatbotPromptEditModal")
        }
        else {
          // refresh screen
          setTimeout(() => {
            this.chatbotPromptView(this.vmchatbotPromptFormData.prompt_id)
          }, 500)
        }
        this.vmchatbotPromptFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    },
    /**
     * chatbotPromptView
     */
    async chatbotPromptView (promptIid) {
      try {
        let chatbotPromptViewResp = await ChatbotPromptApiObj.chatbotPromptView(this, promptIid)
        if (chatbotPromptViewResp && !chatbotPromptViewResp.resp_status) {
          this.toastMsg = "Failed to fetch prompt details"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }
        chatbotPromptViewResp = chatbotPromptViewResp.resp_data.data
        this.vmchatbotPromptFormData = {
          prompt_name: chatbotPromptViewResp.prompt_name,
          prompt_service: chatbotPromptViewResp.prompt_service,
          prompt_module_name: chatbotPromptViewResp.prompt_module_name,
          prompt: chatbotPromptViewResp.prompt,
          prompt_macro: chatbotPromptViewResp.prompt_macro,
          prompt_id: chatbotPromptViewResp.prompt_id
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbotPromptView() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
